import React, {Component} from 'react';
import {Label} from 'reactstrap';
import Uploader2 from '../../components/Uploader/Uploader2';
import processDocument from './processDocument';
import moment from "moment/moment";
import {API_BASE_URL} from "../../constants";
import {request} from "../../util/APIUtils";

class FileModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentMeeting: props.currentMeeting,
            memberInfo: null,
            selectedFile: null,
            fileUploaded: false,
            loading: false,
            fotoPath: '',
            fotoFile: '',
            fotoThumbFile: '',
            fieldsDisabled: false,
            documentInfo: {
                fotoThumbFile: null,
                evrakFile: null,
                evrakPath: null,
            },
        };
        this.onChangeDocument = this.onChangeDocument.bind(this);
    }

    componentDidMount() {
        const {selectedDocument} = this.props;

        if (selectedDocument) {
            const processedDocument = processDocument(selectedDocument);

            this.setState({
                memberInfo: processedDocument,
                fieldsDisabled: selectedDocument.isTransferred,
            });
        }
    }

//Uploader2 bileşeni tarafından kullanılır. Bu fonksiyon, bir dosya bilgisini alır ve bu bilgileri bileşen durumuna (state) kaydeder.
    handleFileChange = (name, value) => {
        console.log(name, value);
        // if (fileInfo && fileInfo.fotoFile) {
        //     this.setState({
        //         selectedFile: fileInfo.fotoFile,
        //         fotoPath: fileInfo.fotoPath,
        //         fotoFile: fileInfo.fotoFile,
        //         fotoThumbFile: fileInfo.fotoThumbFile,
        //     });
        // }
    }

    onChangeDocument(name, value) {
        if (value instanceof moment) {
            value = moment.utc(value.format('DD.MM.YYYY').toString() + " 00:00", "DD.MM.YYYY HH:mm");
        }
        let documentInfo = this.state.documentInfo;
        documentInfo[name] = value;
        // this.setState({documentInfo});
        this.setState(prevState => ({
            ...prevState,
            selectedFile: value
        }))
    }

//belgenin sunucuya yüklenmesini yönetir.
// İlk olarak, seçilen dosya (selectedFile) varsa, işlem başlar.
// Dosya yükleme işlemi için bir FormData nesnesi oluşturulur ve seçilen dosya bu nesneye eklenir.
// Daha sonra, belgenin yükleneceği API'nin son noktası (apiEndpoint) ve istek yöntemi (requestMethod) belirlenir.
// Ardından, fetch ile sunucuya POST isteği gönderilir.
    handleFileUpload = () => {
        console.log(this.state.documentInfo);
        if (this.state.selectedFile) {
            this.setState({ loading: true });
            const base64Data = this.state.documentInfo.evrakFile;
            const documentName = this.state.documentInfo.evrakPath.split('/').pop();

            this.uploadFile(base64Data, documentName);
        }
    }

    uploadFile = (base64Data, documentName) => {
        const apiEndpoint = `${API_BASE_URL}/uploadDocument/${this.state.currentMeeting.id}`;
        const requestMethod = "POST";

        const options = {
            url: apiEndpoint,
            method: requestMethod,
            data: { file: base64Data, documentName: documentName }, // Dosya adı da gönderiliyor // Assuming your API expects the file data in an object field named "file"
        };

        request(options)
            .then((response) => {
                if (response.status === 200) {
                    alert('Dosya başarıyla yüklendi!');
                    this.setState({ fileUploaded: true, loading: false });
                    this.props.onFileUploadComplete(); // Yükleme tamamlandığında üst bileşeni bilgilendirin
                } else {
                    alert('Dosya yükleme hatası');
                    this.setState({ loading: false });
                }
            })
            .catch((error) => {
                console.error('Dosya yükleme hatası:', error);
                alert('Dosya yükleme hatası: ' + error.message);
                this.setState({ loading: false });
            });
    }

    render() {
        return (
            <div className="FormRenk col-sm-12">
                <span className="form-title">Belge Yükleme</span>
                <div className="row">
                    <Label className="col-sm-3">Belge Yükle: </Label>
                    <div className="col-sm-8 form-group">
                        <Uploader2 onInfoChange={this.onChangeDocument}
                                   fileName="evrakFile"
                                   thumbFileName="fotoThumbFile"
                                   filePathName="evrakPath"
                                   pathPrefix="foto"
                                   filePath={this.state.documentInfo.evrakPath}
                                   file={this.state.documentInfo.evrakFile}
                                   thumb={this.state.documentInfo.fotoThumbFile}
                        />
                    </div>
                </div>
                <div className="uploader-container">
                    {this.state.fotoThumbFile && (
                        <img src={this.state.fotoThumbFile} alt="Dosya Önizleme"/>
                    )}
                </div>
                {this.state.selectedFile && !this.state.fileUploaded && !this.state.loading && (
                    <button className="custom-button" onClick={this.handleFileUpload}>
                        Belgeyi Yükle
                    </button>
                )}
                <div className="file-info">
                {this.state.selectedFile && <p>Seçilen Dosya: {this.state.selectedFile.name}</p>}
            </div>
            </div>
        );
    }
}

export default FileModal;



// WEBPACK FOOTER //
// ./src/page/odaList/FileModal.js